import moment from "moment/moment";
import useResources from "./use-resources";

export interface Compteur {
  id: number;
  type: string;
  date_releve: string;
  valeur: number;
  numero_compteur?: string;
}

function sortByDateReleveDesc(a: Compteur, b: Compteur): number {
  return moment(b.date_releve).valueOf() - moment(a.date_releve).valueOf();
}

export default function useCompteurs(
  propId: number | string | null | undefined,
  isFolder: boolean,
) {
  const url = isFolder ? `/property-folders/${propId}` : `/biens/${propId}`;
  const {
    resources: compteurs,
    groupedResources: groupedCompteurs,
    error,
    isLoading,
    create,
    batchUpdate,
    del,
  } = useResources<Compteur>(
    propId ? `${url}/compteurs` : null,
    {},
    { groupBy: { attr: "type", unique: false } },
  );

  function createCompteur(compteur: Partial<Compteur>) {
    return create(compteur, { sort: sortByDateReleveDesc });
  }

  function batchUpdateCompteurs(
    updatedCompteurs: Array<Omit<Compteur, "id"> & { id?: number }>,
    deletedIds: number[],
  ) {
    return batchUpdate(updatedCompteurs, {
      deletedIds,
      sort: sortByDateReleveDesc,
    });
  }

  return {
    compteurs,
    groupedCompteurs: groupedCompteurs as Record<string, Compteur[]>,
    error,
    isLoading,
    createCompteur,
    deleteCompteur: del,
    batchUpdateCompteurs,
  };
}
